import { createBrowserRouter, Navigate } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import InterviewPage from "./app/InterviewPage";
import FamiliesPage from "./app/FamiliesPage";
import CareGiversPage from "./app/CareGiversPage";
import SettingsPage from "./app/SettingsPage";
import CreateCareGiverPage from "./app/CreateCareGiverPage";
import CreateFamilyPage from "./app/CreateFamilyPage";
import CalculationHistoryPage from "./app/CalculationHistoryPage";
import EditFamilyPage from "./app/EditFamilyPage";
import EditCaregiverPage from "./app/EditCaregiverPage";

const appRoutes = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: '/interview', element: <InterviewPage />, index: true},
      { path: '/history', element: <CalculationHistoryPage /> },
      { path: '/families', element: <FamiliesPage /> },
      { path: '/caregivers', element: <CareGiversPage /> },
      { path: '/settings', element: <SettingsPage /> }, 
      { path: '/create_family', element: <CreateFamilyPage /> },
      { path: '/create_care_giver', element: <CreateCareGiverPage /> },
      { path: '/edit_family', element: <EditFamilyPage /> },
      { path: '/edit_caregiver', element: <EditCaregiverPage /> },
    ]
  },
  {
    path: '*',
    element: <Navigate to='/families' />
  }
]);

export default appRoutes;